import { useEffect } from "react";

export default function SEO({
  title,
  description,
  canonical = "https://antoniosaldanhaadvocacia.com.br/",
  keywords = "advogado, advocacia, direito trabalhista, direito penal, direito previdenciario, direito civel, direito empresarial, escritorio de advocacia sao paulo",
  ogImage = "https://antoniosaldanhaadvocacia.com.br/apple-touch-icon.png",
  ogType = "website",
  schemaJson = null,
}) {
  useEffect(() => {
    // 1. Atualizar Título da Página
    if (title) {
      document.title = title;
    }

    // Helper para atualizar ou criar meta tag
    const updateMetaTag = (selector, nameAttr, nameValue, contentValue) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(nameAttr, nameValue);
        document.head.appendChild(element);
      }
      element.setAttribute("content", contentValue || "");
    };

    // Helper para atualizar ou criar link canonical
    const updateCanonical = (hrefValue) => {
      let element = document.querySelector("link[rel='canonical']");
      if (!element) {
        element = document.createElement("link");
        element.setAttribute("rel", "canonical");
        document.head.appendChild(element);
      }
      element.setAttribute("href", hrefValue);
    };

    // 2. Meta Tags de SEO On-Page
    if (description)
      updateMetaTag(
        "meta[name='description']",
        "name",
        "description",
        description,
      );
    if (keywords)
      updateMetaTag("meta[name='keywords']", "name", "keywords", keywords);
    if (canonical) updateCanonical(canonical);

    // 3. Open Graph Tags
    updateMetaTag("meta[property='og:title']", "property", "og:title", title);
    updateMetaTag(
      "meta[property='og:description']",
      "property",
      "og:description",
      description,
    );
    updateMetaTag("meta[property='og:url']", "property", "og:url", canonical);
    updateMetaTag("meta[property='og:image']", "property", "og:image", ogImage);
    updateMetaTag("meta[property='og:type']", "property", "og:type", ogType);
    updateMetaTag(
      "meta[property='og:site_name']",
      "property",
      "og:site_name",
      "Antonio Saldanha Advocacia",
    );
    updateMetaTag(
      "meta[property='og:locale']",
      "property",
      "og:locale",
      "pt_BR",
    );

    // 4. Twitter Card Tags
    updateMetaTag(
      "meta[name='twitter:card']",
      "name",
      "twitter:card",
      "summary_large_image",
    );
    updateMetaTag("meta[name='twitter:title']", "name", "twitter:title", title);
    updateMetaTag(
      "meta[name='twitter:description']",
      "name",
      "twitter:description",
      description,
    );
    updateMetaTag(
      "meta[name='twitter:image']",
      "name",
      "twitter:image",
      ogImage,
    );

    // 5. Injeção de Dados Estruturados (JSON-LD Schema.org)
    let scriptElement = document.getElementById("json-ld-schema");
    if (schemaJson) {
      if (!scriptElement) {
        scriptElement = document.createElement("script");
        scriptElement.id = "json-ld-schema";
        scriptElement.type = "application/ld+json";
        document.head.appendChild(scriptElement);
      }
      scriptElement.textContent = JSON.stringify(schemaJson);
    } else if (scriptElement) {
      scriptElement.remove();
    }
  }, [title, description, canonical, keywords, ogImage, ogType, schemaJson]);

  return null;
}
